var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',[_c('b-navbar',{attrs:{"variant":"faded","type":"light"}},[_c('b-navbar-brand',{staticClass:"my-2",attrs:{"tag":"h1"}},[_vm._v("RowiCoins Store")])],1),_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }